import React from 'react';
import { Link } from 'react-router-dom';

export type SubscriptionTab = 'current-plan' | 'payments' | 'invoices' | 'payment-methods' | 'billing-info';

type Props = {
  activeItem: SubscriptionTab;
};

export const Navigation = ({ activeItem }: Props) => {
  return (
    <div className="col max-250 settings-inner-left-menu">
      <Link
        to="/settings/subscription/current-plan"
        className={
          activeItem === 'current-plan' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Current Plan
      </Link>
      <Link
        to="/settings/subscription/payments"
        className={
          activeItem === 'payments' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Payments
      </Link>
      <Link
        to="/settings/subscription/invoices"
        className={
          activeItem === 'invoices' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Invoices
      </Link>
      <Link
        to="/settings/subscription/payment-methods"
        className={
          activeItem === 'payment-methods'
            ? 'active btn darkGray w100 mb-1 mx-0 px-1'
            : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Payment Methods
      </Link>
      <Link
        to="/settings/subscription/billing-info"
        className={
          activeItem === 'billing-info' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Billing info
      </Link>
    </div>
  );
};
